import { ReactElement, useEffect, useState } from 'react';
import { ProductCard } from './productCard';
import { TaskListProduct } from '@services/hooks/site-leads';
import { IFeedback, IProductDiscussionProps, booleanOptionList, DropdownQuestion } from '.';
import useSiteLeadStore from '@store/siteLeadStore';
import { Modal } from '@components/common/modal/modal';
import { ProductFeedback } from './ProductFeedback';
import { feedbackQuestions, masterFeedbackQuestions } from '@config/feedbackQuestions';
import { VideoPlayer } from '@components/common/videoPlayerModal/videoPlayer';
import { useVideoPlayerStore } from '@store/videoPlayerStore';

export const ProductDiscussion = (props: IProductDiscussionProps): ReactElement => {
	const { products, formik } = props;
	const { isFeedbackModalOpen, setFeedbackModal, feedbackResponseValue, reason, glue, grade } = useSiteLeadStore();

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [feedbackQuestionsNew, _] = useState(masterFeedbackQuestions);
	const { isVideoPlayerOpen, setVideoPlayerState } = useVideoPlayerStore();

	const commonFeedbackProps = {
		formik,
		products,
		action: feedbackResponseValue,
	};

	useEffect(() => {
		products?.forEach((item, index) => {
			if (item?.recommended_from === 'master' && glue === 'F&B') {
				const masterfields = feedbackQuestionsNew.fnb;
				formik.setFieldValue(
					`feedback[${index}]`,
					masterfields?.map((ele) => {
						return {
							id: ele.id,
							productId: item.product_code,
							feedbackQuestion: ele.question,
							feedbackOptions: ele.options,
							feedbackResponse: '',
							type: ele.type,
							placeHolder: ele.placeHolder,
							validation: ele.validation,
						};
					})
				);
			}
			if (item?.recommended_from === 'master' && glue === 'Competition' && reason) {
				const masterfields = feedbackQuestionsNew[reason];
				const result = masterfields?.reduce<IFeedback[]>((acc, ele) => {
					if ((ele.type === 'checkbox' && products[index]?.visit_count < 2) || !ele.question.trim()) {
						return acc;
					}

					acc.push({
						id: ele.id,
						productId: item.product_code,
						feedbackQuestion: ele.question,
						feedbackOptions: ele.options,
						feedbackResponse: '',
						type: ele.type,
						placeHolder: ele.placeHolder,
						validation: ele.validation,
					});

					return acc;
				}, []);

				formik.setFieldValue(`feedback[${index}]`, result);
			}
			if (
				item?.recommended_from === 'master' &&
				glue === 'FV' &&
				grade &&
				(grade?.toLowerCase() === 'sh' || grade?.toLowerCase() === 'marine')
			) {
				formik.setFieldValue(`feedback[${index}]`, []);
			}
			if (item?.recommended_from === 'analytics') {
				const item = products?.[index];
				const fields = feedbackQuestions.analytics;
				const answers = item?.answers;

				const updatedQuestions: DropdownQuestion[] =
					item?.questions && fields && answers
						? Object.entries(item.questions).map(([key, value]) => {
								const answerDetails = answers[key] || {};
								return {
									...answerDetails,
									question: value,
								};
							})
						: [];

				formik.setFieldValue(
					`feedback[${index}]`,
					updatedQuestions.map((ele) => {
						let options: { id: number; value: string }[] = [];

						if (ele.question_type === 'dropdown' && Array.isArray(ele.options)) {
							options = ele.options.map((value: string, idx: number) => ({
								id: idx + 1,
								value,
							}));
						}

						if (ele.question_type === 'boolean') {
							options = booleanOptionList;
						}

						return {
							id: ele.id,
							productId: item?.product_code,
							feedbackQuestion: ele.question,
							feedbackOptions: options,
							feedbackResponse: '',
							type: ele.question_type === 'boolean' ? 'dropdown' : ele.question_type,
							placeHolder: ele.placeHolder || '',
						};
					})
				);
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [glue, products, reason, formik.values.dealers]);

	return (
		<>
			<div className="product-discussion-wrapper">
				<h1 className="list-title">
					<span className="title-wrapper">
						<span className="title-number">1</span>
						<span className="title-name">Product Discussion</span>
					</span>
				</h1>

				<ul className="product-discussion-list row">
					{products?.length ? (
						products?.map((product: TaskListProduct, index) => (
							<ProductCard
								key={`${product.product_name}-${product.id}`}
								product={product}
								productIndex={index}
								action={formik.values.productResponse[index]}
								formik={formik}
								isDefaultProductRecommendation={product.recommended_from === 'default'}
							/>
						))
					) : (
						<li>No Data</li>
					)}
				</ul>
			</div>
			<Modal
				modalId="productFeedback"
				className="dialog-lg dialog-bottom site-product-popup"
				modalOpen={isFeedbackModalOpen}
				onModalClose={() => setFeedbackModal(false)}
			>
				<ProductFeedback {...commonFeedbackProps} />
			</Modal>
			<Modal
				modalId="videoPlayer"
				className="dialog-sm dialog-lg pt-4"
				modalOpen={isVideoPlayerOpen}
				onModalClose={() => setVideoPlayerState(false)}
			>
				<VideoPlayer />
			</Modal>
		</>
	);
};
